<template>
  <div class="trial-table">
    <div class="table-container">
      <div class="inner-scroll">
        <table>
          <thead>
            <td v-for="(heading, keyIndex) in headers" :key="keyIndex" >
              {{heading}}
            </td>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in rows" :key="rowIndex" @click="onRowClick(row)" >
              <td v-for="(key, keyIndex) in columns" :key="keyIndex" >
                {{row[key] | formatRow(key)}}
              </td>
              <td v-if="!singleTrialView && !isSurgeonContext" class="tdbutton">
                <rp-button @click.stop="onView(row)">View</rp-button>
              </td>
              <td class="tdbutton">
                <rp-button :disabled="!getIsClosed(row)" @click.stop="onExport(row)">Export</rp-button>
              </td>
              <td v-if="!isSurgeonContext" class="tdbutton">
                <rp-button :disabled="getIsClosed(row)" @click.stop="onExtend(row)">Extend</rp-button>
              </td>
              <td v-if="!isSurgeonContext" class="tdbutton">
                <rp-button :disabled="getIsClosed(row)" @click.stop="onClose(row)">Close</rp-button>
              </td>
              <td v-if="isSurgeonContext" class="tdbutton">
                <rp-button @click.stop="onViewResponses(row)">View Responses</rp-button>
              </td>
              <td v-if="isAdmin && isSurgeonContext" class="tdbutton">
                <rp-button @click.stop="onRemove(row)">Remove Surgeon</rp-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <rp-pagination v-show="!singleTrialView" :pageInfo="pageInfo" @getData="getTrials"/>
    </div>
  </div>
</template>

<script>
import Button from './inputs/Button'
import Pagination from './Pagination'
import {mapGetters} from 'vuex'

export default {
  components: {
    'rp-button': Button,
    'rp-pagination': Pagination,
  },

  data() {
    return {
      columns: ['name', 'enrolment_target', 'enrolled', 'end_date'],
      headers: ['Study Name', 'Target Enrol', 'Current Enrol', 'End Date'],
    }
  },

  props: {
    rows: Array,
    pageInfo: Object,
    surgeonId: {type: String, default: ''},
    singleTrialView: {type: Boolean, default: false},
  },

  computed: {
    ...mapGetters(['isAdmin']),

    isSurgeonContext() {
      return this.surgeonId !== ''
    }
  },

  methods: {
    async getTrials(pageInfo) {
      this.$emit('getTrials', pageInfo)
    },

    getIsClosed(row) {
      return row.status.status === 'Closed'
    },

    onRowClick(row) {
      this.$emit('onRowClick', row)
    },

    onView(row) {
      this.$emit('onView', row)
    },

    onExport(row) {
      this.$emit('onExport', row)
    },

    onExtend(row) {
      this.$emit('onExtend', row)
    },

    onClose(row) {
      this.$emit('onClose', row)
    },

    onViewResponses(row) {
      this.$emit('onViewResponses', row, this.surgeonId)
    },

    onRemove(row) {
      this.$emit('onRemove', row, this.surgeonId)
    },
  },

  filters: {
    formatRow(value, key) {
      if (key === 'end_date') {
        return value.split('T')[0]
      }
      return value
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '../../styles/base/_variables.sass'
  @import '../../styles/helpers/_mixins.sass'
  @import '../../styles/base/_themes.scss'

  .trial-table
    color: $color-text
    background-color: $color-panel-bg
    border-radius: 10px

    button
      margin-top: 0
      width: 85px

    table
      padding: 10px
      width: 100%
      border-collapse: collapse
      table-layout: fixed

      tr
        td
          &.tdbutton
            padding: 10px

          .status
            display: block

          div
            span
              display: flex
              justify-content: center

    thead
      @include themify($themes)
        background: themed('thead-background')
        color: themed('thead-color')

      font-weight: bold
      text-transform: uppercase
    
      td
        white-space: nowrap
        line-height: 1

        &.tdbutton
          text-align: center

        @include themify($themes)
          padding: themed('thead-td-padding')
          font-weight: themed('thead-td-weight')
          font-size: themed('thead-font-size')
          
        &:first-child 
          @include themify($themes)
            border-radius: themed('td-radius-left')

        &:last-child
          @include themify($themes)
            border-radius: themed('td-radius-right')

    tr
      @include themify($themes)
        border-bottom: themed('tr-border-bottom')
    
      &:first-child
        @include themify($themes)
          border-top: themed('tr-border-top')
      &:last-child
        @include themify($themes)
          border-bottom: 0
      td
        @include themify($themes)
          padding: themed('td-padding')
        
        font-size: 12px

    .pagination
      @include themify($themes)
        border-top: themed('tr-border-top')
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/TrialTable.vue